import { useMutation } from '@apollo/client'
import { DELETE_WALKTHROUGH_QUERY } from '../../App/graphql/queries/walkthrough'

const useDeleteWalkthroughMutation = () => {
  return useMutation(DELETE_WALKTHROUGH_QUERY, {})
}

export default useDeleteWalkthroughMutation
